import Vue from 'vue'
import metricRanges from '@/scripts/definitions/metrics-scales'

/**
 * Validate metric value by returning value or default placeholder when 'null' || 'undefined'
 * A module for adding two values.
 * @name Metric Scale
 * @param {object} - privacy gown
 * @param {object} - security
 * @returns {function}
 */

const getMetricIndex = (value, ranges) => {
  return ranges.indexOf(ranges.reduce((prev, curr) => {
    return value >= curr ? curr : prev
  }))
}

const metricScale = (value, metric, roundFunction = Math.round) => {
  // Null/undefined values
  if (!value && value !== 0) {
    return 'none'
  }
  const ranges = metricRanges[metric].map((l) => l.min)

  if (!ranges) {
    return value === 0 ? 0 : Math.round(Math.floor(value) / 10)
  }

  return getMetricIndex(roundFunction(value), ranges) + 1
}

Vue.filter('metricScale', metricScale)

export default metricScale
